import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getDaysLeftToNextBirthDay } from '../../utils';
import './NextBirthday.scss';

export const NextBirthday = () => {
  const [dateOfBirth, setDateOfBirth] = useState(() => new Date('1990-01-01'));
  const [nextBirthDay, setNextBirthday] = useState(() =>
    getDaysLeftToNextBirthDay(dateOfBirth)
  );
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setTimeout(() => {
      setNextBirthday(() => getDaysLeftToNextBirthDay(dateOfBirth));
      setShowLoader(false);
    }, 1000);
  }, [dateOfBirth]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Next Birthday Calculator</h2>
        <p className='mb-4'>
          Calculate how many days left till your next birthday
        </p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select Your Date of Birth'
            initDate={dateOfBirth}
            setDate={setDateOfBirth}
            maxDate={new Date()}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <h4>Result:</h4>
          <p
            className='mb-0'
            dangerouslySetInnerHTML={{ __html: nextBirthDay }}
          />
          <small className='text-muted'>
            If you were born on February 29, your birthday in a non-leap year
            will be on February 28.
          </small>
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
